<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <!-- <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="申报状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select placeholder="请选择申报状态" showSearch optionFilterProp="children" v-model="queryParam.declareStatus">
                    <a-select-option v-for="(item,index) in declareArr" :key="index" :value="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col> -->
              <a-col :md="12" :lg="10" :xxl="8" :sm="24">
                <a-form-item label="产品名称/UDI编码/GS1编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入产品名称或者UDI编码或者GS1编码" v-model="queryParam.keywords"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="12" :lg="10" :xxl="8" :sm="24">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品标识体系编码名称">

                <a-select style="width:90%;" showSearch optionFilterProp="children" v-model="queryParam.codeSystem" :allowClear="true">
                  <a-select-option v-for="(item,index) in matype" :key="index" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                  <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ toggleSearchStatus ? '收起' : '展开' }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                  </a> -->
                </a-col>
              </span>
              <!-- <template v-if="toggleSearchStatus">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="会员卡号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="选择会员卡号" showSearch optionFilterProp="children" v-model="queryParam.organId">
                      <a-select-option v-for="(item,index) in retailList" :key="index" :value="item.id">
                        {{ item.supplier }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="仓库名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="请选择仓库" showSearch optionFilterProp="children" v-model="queryParam.depotId">
                      <a-select-option v-for="(depot,index) in depotList" :value="depot.id">
                        {{ depot.depotName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="操作员" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="选择操作员" showSearch optionFilterProp="children" v-model="queryParam.creator">
                      <a-select-option v-for="(item,index) in userList" :key="index" :value="item.id">
                        {{ item.userName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="结算账户" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="选择结算账户" showSearch optionFilterProp="children" v-model="queryParam.accountId">
                      <a-select-option v-for="(item,index) in accountList" :key="index" :value="item.id">
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="单据状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="选择单据状态" v-model="queryParam.status">
                      <a-select-option value="0">未审核</a-select-option>
                      <a-select-option value="1">已审核</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="单据备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入单据备注" v-model="queryParam.remark"></a-input>
                  </a-form-item>
                </a-col>
              </template> -->
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operator" style="margin-top: 5px">
          <a-button @click="myHandleAddDI" type="primary">注册产品DI</a-button>
          <a-button @click="asyncDiInfo" type="primary">同步DI信息</a-button>
          <!-- <a-button @click="myHandleAdd" type="primary">批量导入DI</a-button>
          <a-button @click="myHandleAdd" type="primary">下载模版</a-button>
          <a-button @click="myHandleAdd" type="primary">批量下载DI</a-button>
          <a-button @click="myHandleAdd" type="primary">同步产品</a-button> -->
        </div>
        <!-- table区域-begin -->
        <div>
          <a-table ref="table" size="middle" :rowKey="(record,index)=>{return index}"
                   bordered :columns="columns" :dataSource="dataSource" :components="handleDrag(columns)"
                   :pagination="ipagination"  :scroll="{ x: true }"  :loading="loading"
                   :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,columnWidth:'30px' }"
                   @change="handleTableChange"
                  style="word-break:break-all"
          >
            <span slot="action" slot-scope="text, record" >
              <a-button type="primary" v-if="record.status !== -1" @click="HandleStandard(record)">添加包装规格</a-button>
              <a-divider type="vertical" />
              <a-button type="primary" v-if="record.status !== -1" @click="EditDi(record)">编辑</a-button>
              <a-divider type="vertical" />
              <a-popconfirm title="确定隐藏吗?" @confirm="() => myHandleDelete(record)">
                <a-button type="primary">隐藏</a-button>
              </a-popconfirm>
              <a-divider type="vertical" />
              <a-button style="width: 116px" type="primary" v-if="record.declareStatus == 0 && record.status !== -1 " @click="myHandleCopyAdd(record)" >药监局申报</a-button>
<!--              <a-divider v-if="record.declareStatus == 0 && record.status !== -1 " type="vertical" />-->
              <a-button type="primary" v-else-if="record.declareStatus == 1 && record.status !== -1 " @click="myHandleCopyAdd(record)">药监局更新</a-button>
              <a-button disabled type="info" v-else-if="record.declareStatus == 2 && record.status !== -1 ">信息已提交</a-button>
              <a-button type="primary" v-else-if="record.declareStatus == 3 && record.status !== -1 " @click="myHandleCopyAdd(record)">药监局更新</a-button>
              <a-button style="width: 116px" disabled type="info" v-else-if="record.declareStatus == -1 && record.status !== -1 ">未完善信息</a-button>
<!--              <a-button style="width: 116px" disabled type="info" v-else-if="record.codeSystem == 2">暂不支持申报</a-button>-->


            </span>
            <template slot="declareStatus" slot-scope="declareStatus">
              <span v-if="declareStatus === -2">不允许申报</span>
              <span v-else-if="declareStatus === -1">资料未完善</span>
              <span v-else-if="declareStatus === 0">未申报</span>
              <span v-else-if="declareStatus === 1">已填报</span>
              <span v-else-if="declareStatus === 2">已提交</span>
              <span v-else-if="declareStatus === 3">已提交</span>
            </template>
            <template slot="codeSystem" slot-scope="codeSystem">
              <span v-if="codeSystem === '1'">MA(IDcode)</span>
              <span v-else-if="codeSystem === '2'">GS1</span>
              <span v-else-if="codeSystem === ''">MA(IDcode)</span>
            </template>
          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->
        <addDImodel v-if="showmodel" ref="modalForm" @ok="modalFormOk" @close="modalFormClose"></addDImodel>
        <standardslistModel ref="standardModelref" @ok="modalFormOk" @close="modalFormClose"></standardslistModel>
        <reportModel ref="reportModelref" @ok="modalFormOk" @close="modalFormClose"></reportModel>
      </a-card>
    </a-col>
  </a-row>
</template>
<!-- create ji sheng hua-->
<script>
import standardslistModel from './modules/standardslistModel'
import addDImodel from './modules/addDImodel'
import reportModel from './modules/reportModel'
// import BillDetail from './dialog/BillDetail'
// import BillExcelIframe from '@/components/tools/BillExcelIframe'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { BillListMixin } from './mixins/BillListMixin'
import JEllipsis from '@/components/jeecg/JEllipsis'
import JDate from '@/components/jeecg/JDate'
import Vue from 'vue'
import { productDidel,asyncDiInfoApi } from '@/api/api'


export default {
  name: 'RetailOutList',
  mixins: [JeecgListMixin, BillListMixin],
  components: {
    addDImodel,
    standardslistModel,
    reportModel,
    JEllipsis,
    JDate,
  },
  data() {
    return {
      showmodel:false,
      declareArr: [
        // 申报状态
        {
          label: '不允许申报',
          value: -2,
        },
        {
          label: '资料未完善',
          value: -1,
        },
        {
          label: '未申报',
          value: 0,
        },
        {
          label: '已填报',
          value: 1,
        },
        {
          label: '已提交',
          value: 2,
        },
      ],
      matype: [
        {
          label: 'MA码(IDcode)',
          value: '1',
        },
        {
          label: 'GS1',
          value: '2',
        }
      ],
      // 查询条件
      queryParam: {
        keywords: '',
        codeSystem: '',

        // declareStatus: undefined,
      },
      prefixNo: 'LSCK',
      labelCol: {
        span: 5,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },
      // 默认索引

      // 默认列
      columns: [
        { title: '产品UDI-DI编码', dataIndex: 'productDi', width: 150, ellipsis: true },
        {
          title: '产品名称',
          dataIndex: 'productName',
          width: 80,
        },
        { title: '编码类型', dataIndex: 'codeSystem', width: 100, scopedSlots: { customRender: 'codeSystem' } },
        { title: '规格型号', dataIndex: 'specificationModel', width: 100, ellipsis: true },
        { title: '申报状态', dataIndex: 'declareStatus', width: 80, scopedSlots: { customRender: 'declareStatus' } },
        { title: '发布时间', dataIndex: 'releaseTime', width: 80 },
        { title: '申报时间', dataIndex: 'createTime', width: 80, ellipsis: true },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'left',
          width: 250,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/productDi/list',
        delete: '/depotHead/delete',
        deleteBatch: '/depotHead/deleteBatch',
        batchSetStatusUrl: '/depotHead/batchSetStatus',
      },
    }
  },
  computed: {},
  created() {
    // this.initSystemConfig()
    this.initRetail()
    this.getDepotData()
    this.initUser()
    this.initAccount()
  },
  methods: {
    // 药监局申报
    myHandleCopyAdd(record) {
      this.$refs.reportModelref.add(record)
    },
    modalFormOk(){
      this.loadData()
    },
    // 删除
    async myHandleDelete(record) {
      const res = await productDidel({ id: record.id })
      if (res.errno == 200 && res.errmsg == '成功') {
        this.$message.success('删除成功')
        this.loadData()
      } else {
        this.$message.error(res.data || res.errmsg)
      }
    },
    // 添加包装规格
    HandleStandard(record) {
      this.$refs.standardModelref.add(record)
    },
    gostandards() {},
    async asyncDiInfo(){
      let that = this
      const res = await asyncDiInfoApi({  })
      // this.$confirm({
      //   title: "提示",
      //   content: res.message,
      //   onOk: function () {
      //     that.searchQuery()
      //   }
      // })
      this.$confirm(res.message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.searchQuery()
      })

    },
    // 注册DI
    myHandleAddDI() {
      const holdData = localStorage.getItem('holdData')
      this.showmodel = false
      this.$nextTick(()=>{
        this.showmodel = true
        this.$nextTick(()=>{
          if ( holdData ) {
            const newHoldData = JSON.parse(holdData) // 在接收端反序列化字符串回对象
            this.$refs.modalForm.add(newHoldData)
            this.$refs.modalForm.title = '新增产品DI'
          } else {
            this.$refs.modalForm.add()
            this.$refs.modalForm.title = '新增产品DI'
          }
        })
      })
    },
    EditDi(record) {
      this.showmodel = true
      this.$nextTick(()=>{
        this.$refs.modalForm.edit(record)
        this.$refs.modalForm.title = '编辑产品DI'
      })
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
